function cardInit(id) {
	let wsLandingMarginLeft, wsMarginLeft;
	let year = $('.sw_pre.sw_act').length;
	let underline = $('.ws-landing .ws-landing__price__card__body__price-underline');
	if (year) underline.show(); else underline.hide();
	underline.html(ws_landing_data[id]['price']);

	$('.ws-landing .ws-landing__price__card__row:first-child .ws-landing__price__card__progress__fill').css({width: (year ? ws_landing_data[id]['y_style1'] : ws_landing_data[id]['style1']) + '%'});
	$('.ws-landing .ws-landing__price__card__row:last-child .ws-landing__price__card__progress__fill').css({width: (year ? ws_landing_data[id]['y_style2'] : ws_landing_data[id]['style2']) + '%', borderRadius: '12px 2px 2px 12px'});
	$('.ws-landing .ws-landing__price__card__row:first-child .ws-landing__price__card__label b').html(year ? ws_landing_data[id]['y_price1'] : ws_landing_data[id]['price1']);
	$('.ws-landing .ws-landing__price__card__row:last-child .ws-landing__price__card__label b').html(year ? ws_landing_data[id]['y_price2'] : ws_landing_data[id]['price2']);
	$('.ws-landing .ws-landing__price__card.ws-landing__price__card-dark .ws-landing__price__card__title b').html(ws_landing_data[id]['name']);
	$('.ws-landing .ws-landing__price__card.ws-landing__price__card-dark .ws-landing__price__card__title span').html(ws_landing_data[id]['text0']);
	$('.ws-landing .ws-landing__price__list__item:nth-child(1) span').html(ws_landing_data[id]['text1']);
	$('.ws-landing .ws-landing__price__list__item:nth-child(2) span').html(ws_landing_data[id]['text2']);
	$('.ws-landing .ws-landing__price__list__item:nth-child(3) span').html(ws_landing_data[id]['text3']);
	$('.ws-landing .ws-landing__price__card__body__price b').html(year ? ws_landing_data[id]['y_price'] : ws_landing_data[id]['price']);
	$('.ws-landing .ws-landing__price__slider__line.line').hide();
	$('.ws-landing .ws-landing__price__slider__line.line-' + id).show();
	if (ws_landing_data[id]['style2'] === '100') $('.ws-landing .ws-landing__price__card__row:last-child .ws-landing__price__card__progress__fill').css({width: 'calc(100% - 8px)', borderRadius: '12px'});

	wsLandingMarginLeft = 'calc(' + (year ? ws_landing_data[id]['y_style2'] : ws_landing_data[id]['style2']) + '%';
	wsLandingMarginLeft += year ? (ws_landing_data[id]['y_style2'] === '100' ? ' - 4px)' : ' + 4px)') : (ws_landing_data[id]['style2'] === '100' ? ' - 4px)' : ' + 4px)');
	// wsMarginLeft = 'calc(' + (year ? ws_landing_data[id]['y_style1'] : ws_landing_data[id]['style1']) + '%' + ($(window).width() < 600 ? ' - 60px)' : ' - 20px)');
	wsMarginLeft = $(window).width() < 390 ? '-52px' : 'calc(' + (year ? ws_landing_data[id]['y_style1'] : ws_landing_data[id]['style1']) + '%' + ($(window).width() < 600 ? ' - 60px)' : ' - 11px)');
	$('.ws-landing .ws-landing__price__card__row:last-child .ws-landing__price__card__progress__after').css({marginLeft: wsLandingMarginLeft});
	$('.ws-landing .ws-landing__price__card__row:first-child .ws-landing__price__card__progress__after').css({marginLeft: wsMarginLeft});
}

cardInit(50);
$(document).ready(function () {
	if ($('.ws-landing--skip-decoration').length === 0) {
		// VS-list decoration
		$('.ws-landing__list__item').each((_, el) => {
			const $el = $(el);
			$el.html('<span>'+$el.html()+'</span>');
			if ($el.hasClass('ws-landing__list__item-active')) {
				$el.prepend('<svg><use xlink:href="/assets/img/blocks/icons-sprite.svg#done"></use></svg>');
			}
			if ($el.hasClass('ws-landing__list__item-disable')) {
				$el.prepend('<svg><use xlink:href="/assets/img/blocks/icons-sprite.svg#cross"></use></svg>');
			}
		});
	}
	$('.ws-landing__price__slider').on('dragstart', function () {
		return false
	}).on('mousedown touchstart', function (e) {
		var touch = e;
		if (e.type == 'touchstart') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
		touch_x = touch.pageX;
		touch_y = touch.pageY;
		touch_t = 0;
	});
	$(window).on('mousemove touchmove', function (e) {
		let size = $('.ws-landing__price__slider .item_act').width();
		if (touch_t == 0) {
			var touch = e;
			if (e.type == 'touchmove') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
			if (touch.pageX >= touch_x + size) {
				if ($('.ws-landing__price__slider .item_act').next().length) {
					cardInit($('.ws-landing__price__slider .item_act').next().attr('data-id'));
					$('.ws-landing__price__slider .item_act').next().trigger('click');
					touch_x = touch.pageX;
				}
			} else if (touch.pageX <= touch_x - size) {
				if ($('.ws-landing__price__slider .item_act').prev().length) {
					cardInit($('.ws-landing__price__slider .item_act').prev().attr('data-id'));
					$('.ws-landing__price__slider .item_act').prev().trigger('click');
					touch_x = touch.pageX;
				}
			}
		}
	});
});